const logDebugError = (...messages: Array<unknown>): void => {
    console.debug('%c ✘', 'color: #e74c3c;', ...messages);
};

const logDebugInfo = (...messages: Array<unknown>): void => {
    console.debug('%c ℹ', 'color: #3498db;', ...messages);
};

const logDebugSuccess = (...messages: Array<unknown>): void => {
    console.debug('%c ✔', 'color: #2ecc71;', ...messages);
};

const logDebugWarning = (...messages: Array<unknown>): void => {
    console.debug('%c ⚠', 'color: #f1c40f;', ...messages);
};

export { logDebugError, logDebugInfo, logDebugSuccess, logDebugWarning };
